
{
  "options": {
    "sm": "Small",
    "md": "Medium",
    "lg": "Large"
  },
  "label": "Logo Size"
}
